import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // ✅ import เพิ่ม
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    {" "}
    {/* ✅ ครอบ App */}
    <App />
  </BrowserRouter>
);

// วัด performance ถ้าต้องการ
reportWebVitals();
